<template>
  <div class="container" v-if="questionnaire.status">
    <div class="row">
      <div
        class="col-md-8"
        style="margin: 0 auto"
        v-if="questionnaire.status === 1"
      >
        <h2 class="title" style="color: #f5a323">{{ questionnaire.title }}</h2>
        <p
          class="title"
          style="color: #666; font-weight: normal; display: block; padding: 0"
        >
          {{ questionnaire.description }}
        </p>
        <div style="border: 1px dotted #bfbfbf; margin: 10px"></div>
        <div class="coverImg" v-if="questionnaire.coverImg">
          <img :src="questionnaire.coverImg" alt />
        </div>

        <div
          class="infoItemContent"
          v-for="question in questionList"
          :key="question.questionId"
        >
          <div class="infoItem">
            <div class="quest-item">
              <p>
                <span
                  style="color: #f00"
                  v-if="question.required === 0 && question.questionType !== 3"
                  >*&nbsp;</span
                >
                <span>{{ question.sequence }}.</span>
                <span v-html="question.content"></span>
                <span>{{
                  question.multiple && question.questionType === 1
                    ? '【多选题】'
                    : !question.multiple && question.questionType === 1
                    ? '【单选题】'
                    : question.questionType === 3
                    ? ''
                    : '【填空题】'
                }}</span>
              </p>
            </div>

            <div class="input-box">
              <div v-for="item in question.questionItems" :key="item.itemCode">
                <div
                  v-if="
                    question.multiple === false && question.questionType === 1
                  "
                  class="input-item"
                >
                  <van-radio-group v-model="question.radioChecked">
                    <van-radio
                      :disabled="disabled"
                      @click="radioChange(question)"
                      :name="item.itemCode"
                      icon-size="18px"
                      checked-color="#f5a323"
                      >{{ item.itemValue }}</van-radio
                    >
                  </van-radio-group>
                </div>
                <div
                  v-if="
                    question.multiple === true && question.questionType === 1
                  "
                  class="input-item"
                >
                  <van-checkbox-group
                    v-model="question.checkboxChecked"
                    @change="radioChange(question)"
                  >
                    <van-checkbox
                      :disabled="disabled"
                      :name="item.itemCode"
                      shape="square"
                      icon-size="18px"
                      checked-color="#f5a323"
                      >{{ item.itemValue }}</van-checkbox
                    >
                  </van-checkbox-group>
                </div>
              </div>
              <div v-if="question.questionType === 2">
                <van-cell-group @change="radioChange(question)">
                  <van-field
                    v-model="question.inputValue"
                    placeholder="请输入"
                  />
                </van-cell-group>
              </div>
            </div>
          </div>
        </div>
        <div class="getBtn">
          <mt-button
            type="primary"
            class="btn"
            @click.native.prevent="commit()"
            :disabled="disabled"
            >{{ disabled ? '问卷已提交' : '提交' }}</mt-button
          >
        </div>
      </div>
      <div class="col-md-8" style="margin: 0 auto" v-else>
        <div class="questionHeader">
          <img src="../../assets/img/lumi.png" alt />
          <span>问卷调查</span>
        </div>
        <div class="questionStatus">
          <img src="../../assets/img/start.jpg" alt />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Questionnaire',
  data() {
    return {
      inputValue: '',
      questionList: [],
      radioParentId: '',
      checkParentId: '',
      projectId: '',
      checkQuestions: [],
      userId: '',
      disabled: false,
      questionnaire: {}
    }
  },
  created() {
    this.projectId = location.href.split('=')[1]
  },
  mounted() {
    this.initDataList()
    this.getUser()
  },
  methods: {
    initDataList() {
      this.$http({
        url: `/live/questionnaire/queryRedis/${this.projectId}`,
        method: 'get'
      }).then(({ data }) => {
        if (data && data.code === 0) {
          //1. 获取所有questions值

          let questions = data.data.questions
          if (questions != null) {
            questions.forEach((e, index) => {
              if (e.multiple == true && e.questionType === 1) {
                e.checkboxChecked = []
              }
              if (e.multiple == false && e.questionType === 1) {
                e.radioChecked = ''
              }
              if (e.questionType === 2) {
                e.inputValue = ''
              }
            })
          }
          this.questionList = questions
          this.questionnaire = data.data
        } else {
          // this.$toast(data.msg)
        }
      })
    },
    // 值发生变化
    radioChange(parent) {
      this.getPassword()

      this.radioParentId = parent.questionId
    },
    getPassword() {
      let res = []

      let questions = this.questionList

      questions.forEach(e => {
        if (e.questionType === 1) {
          let obj = {
            questionId: e.questionId,
            content: e.content,
            sequence: e.sequence,
            multiple: e.multiple,
            questionType: e.questionType,
            questionItems: [
              {
                item_code:
                  e.multiple == true
                    ? e.checkboxChecked.join(',')
                    : e.radioChecked
              }
            ]
          }
          res.push(obj)
        }
        if (e.questionType === 2) {
          let obj = {
            questionId: e.questionId,
            content: e.content,
            sequence: e.sequence,
            multiple: e.multiple,
            questionType: e.questionType,
            answer: e.inputValue
          }
          res.push(obj)
        }
      })
      let newObj = {
        projectId: this.projectId,
        questions: res
      }
      let newArr = []
      newArr.push(newObj)
      this.checkQuestions = newObj
    },

    // 获取用户userId
    getUser() {
      const openId = sessionStorage.getItem('openId')
      this.$http({
        url: '/live/liveUsers/getUserDetail',
        method: 'get',
        params: { openId }
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.userId = data.user.userId
        }
      })
    },
    // 提交
    commit() {
      // if (this.checkQuestions.length <= 0) {
      //   this.$toast('问卷不能为空')
      //   return this
      // }
      let arr = this.questionList

      let flag = false
      let msg = []
      arr.forEach((e, index) => {
        if (e.required === 0) {
          if (
            e.questionType === 1 &&
            e.multiple === false &&
            e.radioChecked === ''
          ) {
            msg.push(e.sequence)
            flag = true
          }
          if (
            e.questionType === 1 &&
            e.multiple === true &&
            e.checkboxChecked.length <= 0
          ) {
            msg.push(e.sequence)
            flag = true
          }
          if (e.questionType === 2 && e.inputValue === '') {
            msg.push(e.sequence)
            flag = true
          }
        }
      })
      if (flag) {
        this.$toast('问题 ' + msg.join(',') + ' 未填写')
        return this
      }
      this.$http({
        url: '/live/answerresult/saveAnswer',
        method: 'post',
        dataType: 'json',
        data: {
          questionnaire: JSON.stringify(this.checkQuestions),
          userId: this.userId
        }
      }).then(({ data }) => {
        if (data && data.code === 0) {
          // this.$toast(data.msg)
          this.disabled = true
          // this.$router.push('/submitSuccess')
          const routeData = this.$router.resolve({
            path: '/submitSuccess'
            //         query: { catId: catId }
          })
          window.open(routeData.href, '_blank')
        } else {
          this.$toast(data.msg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep p {
  display: inline;
  padding-left: 10px;
  line-height: 30px;
}
::v-deep img {
  width: 90%;
  margin: 0 auto;
  display: block;
}
/deep/.van-checkbox__label--disabled {
  color: #323233;
}
/deep/ .van-radio__label--disabled {
  color: #323233;
}
/deep/ .van-checkbox__icon--disabled.van-checkbox__icon--checked .van-icon {
  color: #f5a323;
}
/deep/ .van-radio__icon--disabled.van-radio__icon--checked .van-icon {
  color: #f5a323;
}
.questionHeader {
  padding: 2rem;
  font-size: 20px;
  margin-bottom: 80px;
  span {
    padding-left: 20px;
  }
  img {
    width: 48px;
  }
}
.questionStatus {
  text-align: center;
  font-size: 20px;

  span {
    padding-left: 20px;
  }
  img {
    width: 100%;
  }
}
.coverImg {
  padding: 1rem;
  width: 100%;
  height: 200px;
  img {
    width: 100%;
    height: 100%;
    // border-radius: 10px;
  }
}
.title {
  text-align: center;
  margin: 2rem 1rem;
  font-weight: bolder;
}
.infoItemContent {
  .input-box {
    margin: 0 1rem;
    .input-item {
      margin: 10px;
    }
  }
  .quest-item {
    margin: 0 10px;
    font-weight: bold;
    span {
      font-weight: normal;
      color: #666;
    }
  }
}
.getBtn {
  box-sizing: border-box;
  margin-top: 20px;
  height: 55px;
  padding-bottom: 1rem;
  text-align: center;
  width: 100%;
  background-color: #fff;
  .btn {
    width: 90%;
    height: 100%;
    font-size: $font-title;
    border-radius: 10px;
    line-height: 36px;
  }
  .btn:hover {
    color: #fff;
    text-decoration: none;
    border: none;
  }
  .btn:focus,
  .btn.focus {
    outline: 0;
    box-shadow: none;
  }
}
</style>
